$(window).scroll(function () {
  $('.fadein').each(function () {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 150) {
      $(this).addClass('scrollin');
    }
  });
});
$(function () {
  $('.fv_fade').addClass('scrollin');
})

// welsh_fv 
$(function () {
  var thisDiv = '.welsh_fv';
  let posiAboutTop = $(thisDiv).offset().top;
  let winH = $(window).height();
  posiAboutTop = posiAboutTop - (winH / 2);

  $(window).scroll(function () {
    let scrollTop = $(this).scrollTop();
    let windowSize = window.innerWidth;
    let transYposi;
    let bgposiY;
    if (windowSize < 768) {
      transYposi = 70;
      bgposiY = 90;
    } else {
      transYposi = 10;
      bgposiY = -300;
    }

    if (scrollTop >= posiAboutTop) {
      let movePx = (transYposi - -(scrollTop - posiAboutTop)) / 5;
      let moveYposiPx = (bgposiY - -(scrollTop - posiAboutTop)) / 5;
      movePx = transYposi - movePx;
      moveYposiPx = bgposiY + movePx;

      //jQuery('.welsh_fv .inner_about').css('transform', 'translateY(' + movePx + 'px)');
      $(thisDiv).css('background-position-y', moveYposiPx + 'px');
    }
  });
})

// welsh_movie 
$(function () {
  var thisDiv = '.welsh_movie';
  let posiAboutTop = $(thisDiv).offset().top;
  let winH = $(window).height();
  posiAboutTop = posiAboutTop - (winH / 2);

  $(window).scroll(function () {
    let scrollTop = $(this).scrollTop();
    let windowSize = window.innerWidth;
    let transYposi;
    let bgposiY;
    transYposi = 0;
    bgposiY = 0;

    if (scrollTop >= posiAboutTop) {
      let movePx = (transYposi - -(scrollTop - posiAboutTop)) / 5;
      let moveYposiPx = (bgposiY - -(scrollTop - posiAboutTop)) / 5;
      movePx = transYposi - movePx;
      moveYposiPx = bgposiY + movePx;

      //jQuery('.welsh_fv .inner_about').css('transform', 'translateY(' + movePx + 'px)');
      $(thisDiv).css('background-position-y', moveYposiPx + 'px');
    }
  });
})

// welsh_safty 
$(function () {
  var thisDiv = '.welsh_safty';
  let posiAboutTop = $(thisDiv).offset().top;
  let winH = $(window).height();
  posiAboutTop = posiAboutTop - (winH / 2);

  $(window).scroll(function () {
    let scrollTop = $(this).scrollTop();
    let windowSize = window.innerWidth;
    let transYposi;
    let bgposiY;
    transYposi = 0;
    bgposiY = 0;

    if (scrollTop >= posiAboutTop) {
      let movePx = (transYposi - -(scrollTop - posiAboutTop)) / 5;
      let moveYposiPx = (bgposiY - -(scrollTop - posiAboutTop)) / 5;
      movePx = transYposi - movePx;
      moveYposiPx = bgposiY + movePx;

      //jQuery('.welsh_safty .inner_about').css('transform', 'translateY(' + movePx + 'px)');
      $(thisDiv).css('background-position-y', moveYposiPx + 'px');
    }
  });
})


// 商品一覧
var galleryTop_lp_w = new Swiper(".lp_welsh_items_outer", {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerView: 1.3,
  loop: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 4,
      navigation: {
        nextEl: ".swiper-button-lp_welsh-next",
        prevEl: ".swiper-button-lp_welsh-prev",
      },
    },
  },
});